/**
 * Utilitários gerais para operações comuns
 */

/** Formata um número como percentual com 2 casas decimais. */
export function formatarPercentual(value: number | null | undefined, defaultValue = '100.00%'): string {
  if (value === null || value === undefined || isNaN(value)) {
    return defaultValue;
  }
  return `${value.toFixed(2)}%`;
}

/** Faz parse seguro de JSON, retornando defaultValue em caso de erro. */
export function parseJSONSafe<T>(jsonString: string | null, defaultValue: T): T {
  if (!jsonString) {
    return defaultValue;
  }

  try {
    return JSON.parse(jsonString) as T;
  } catch (e) {
    return defaultValue;
  }
}

export function estaEntre(value: number, min: number, max: number): boolean {
  return value >= min && value <= max;
}

export function coalesce<T>(...values: (T | null | undefined)[]): T | undefined {
  return values.find(v => v !== null && v !== undefined) as T | undefined;
}

/**
 * Ordena uma lista por nome (alfabética, case-insensitive) ou por um campo numérico
 * (ex.: número de chamada), na direção informada. Compartilhado entre telas de
 * frequência que ordenam a mesma lista de alunos de formas equivalentes.
 */
export function ordenarPorNomeOuChamada<T>(
  lista: T[],
  getNumero: (item: T) => number | undefined,
  getNome: (item: T) => string | undefined,
  tipo: 'alfabetica' | 'numeroChamada',
  direcao: 'asc' | 'desc'
): T[] {
  const resultado = [...lista];
  const multiplicador = direcao === 'asc' ? 1 : -1;

  if (tipo === 'alfabetica') {
    return resultado.sort((a, b) =>
      (getNome(a) || '').toLowerCase().localeCompare((getNome(b) || '').toLowerCase(), 'pt-BR') * multiplicador
    );
  }

  return resultado.sort((a, b) => {
    const numA = getNumero(a) ?? 999;
    const numB = getNumero(b) ?? 999;
    return (numA - numB) * multiplicador;
  });
}

/**
 * Escapa caracteres HTML especiais. Usar antes de interpolar valores vindos
 * de dados de usuário/API em strings destinadas a `[innerHTML]`.
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}


